import { Box } from '@mui/material';
import { LEVEL_TONE, LOAD_LEVELS } from '../utils/constants';

/** The pill for a load level: Overloaded, At capacity, Balanced, Available. */
export default function LoadTag({ level, small = false }) {
  const tone = LEVEL_TONE[level];
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        whiteSpace: 'nowrap',
        borderRadius: 999,
        px: small ? 1 : 1.25,
        py: small ? 0.125 : 0.25,
        fontSize: small ? 11 : 12,
        fontWeight: 700,
        bgcolor: tone.bg,
        color: tone.text,
      }}
    >
      <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: tone.accent }} />
      {LOAD_LEVELS[level].label}
    </Box>
  );
}
